import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { getMediaPath, reactParserCommonOptions } from '../app/functions';
import HeaderGallery from 'pages/customer-join/sections/HeaderGallery';

const ContentSection = ({ section, backgroundColor, fontWeight }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();

  if (!section) return null;

  const isDeepLink = (link) => {
    return link?.linkType === 'deeplink';
  }
  
  const isExternalLink = (link) => {
    return link?.linkType === 'external';
  }
  
  const processBannerLink = (bannerLink) => {
    if (!bannerLink) return '#';

    if (isDeepLink(bannerLink)) {
      return bannerLink.link;
    }
    if (isExternalLink(bannerLink)) {
      return bannerLink.link;
    }
    
    if (bannerLink.link?.startsWith('http') || bannerLink.link?.startsWith('https')) {
      try {
        const url = new URL(bannerLink.link);
        return url.pathname;
      } catch (e) {
        console.error('Invalid URL:', bannerLink.link);
        return '#';
      }
    }
    
    return bannerLink.link || '#';
  };

  const renderContentItem = (item, index) => {
    const hasBanner = item.desktopBanner || item.mobileBanner;
    const hasText = item.text || item.mobileText;
    
    const displayText = isMobile && item.mobileText ? item.mobileText : item.text;

    return (
      <Box key={index} sx={{ backgroundColor: backgroundColor }}>
        {hasBanner && (
          <HeaderGallery 
            data={{
              galleryDesktop: item.desktopBanner ? [{
                id: index, 
                imagePath: getMediaPath(item.desktopBanner), 
                link: section.link,
                linkType: section?.linkType
              }] : [],
              galleryMobile: item.mobileBanner ? [{
                id: index, 
                imagePath: getMediaPath(item.mobileBanner), 
                link: section.link,
                linkType: section?.linkType
              }] : []
            }} 
            testID="header-gallery-section" 
            aspectRatioDesktop={2560/500}
            aspectRatioMobile={500/400}
            onSlideClick={(slide) => {
              if (slide.link) {
                if (isExternalLink(slide) || isDeepLink(slide)) {
                  window.open(slide.link, '_blank');
                  return;
                }
                const processedLink = processBannerLink(slide);
                if (processedLink !== '#') {
                  history.push(processedLink);
                }
              }
            }}
          />
        )}
        {hasText && displayText && (
          <Typography sx={{padding: !isMobile ? '20px 30px' : '10px', fontWeight: fontWeight || 400}} gutterBottom>
            {ReactHtmlParser(displayText, reactParserCommonOptions())}
          </Typography>
        )}
      </Box>
    );
  };

  const contentItems = section.contentItemsData || [];

  if (contentItems.length === 0) {
    const hasBanner = section.desktop_banner || section.mobile_banner;
    const hasText = section.text;
    const displayText = isMobile && section.text_mobile ? section.text_mobile : section.text;

    return (
      <Box key={section.id} sx={{ backgroundColor: backgroundColor }}>
        {hasBanner && section.desktop_banner && section.mobile_banner && (
          <HeaderGallery 
            data={{
              galleryDesktop: [{
                id: 0, 
                imagePath: getMediaPath(section.desktop_banner), 
                link: section.link,
                linkType: section?.linkType
              }],
              galleryMobile: [{
                id: 0, 
                imagePath: getMediaPath(section.mobile_banner), 
                link: section.link,
                linkType: section?.linkType
              }]
            }} 
            testID="header-gallery-section" 
            aspectRatioDesktop={2560/500}
            aspectRatioMobile={500/400}
            onSlideClick={(slide) => {
              if (slide.link) {
                if (isExternalLink(slide) || isDeepLink(slide)) {
                  window.open(slide.link, '_blank');
                  return;
                }
                const processedLink = processBannerLink(slide);
                if (processedLink !== '#') {
                  history.push(processedLink);
                }
              }
            }}
          />
        )}
        {hasText && displayText && (
          <Typography sx={{padding: !isMobile ? '20px 30px' : '10px 0px', fontWeight: fontWeight || 400}} gutterBottom>
            {ReactHtmlParser(displayText, reactParserCommonOptions())}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box key={section.id} sx={{ backgroundColor: backgroundColor }} >
      {contentItems.map((item, index) => renderContentItem(item, index))}
    </Box>
  );
};

export default ContentSection;
